import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import Button from "components/Button";

const StyledButton = styled(Button)`
  margin: auto;
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  z-index: 2;

  ${({ theme }) => theme.mq.lg`
    width: 10rem;
  `}
`;

const SearchAreaButton = ({
  handleSearchArea
}) => {
  return (
    <StyledButton
      outlineType="outline"
      outlineTransparent={false}
      onClick={handleSearchArea}
    >
      Search this area
    </StyledButton>
  )
};

export default SearchAreaButton;

SearchAreaButton.propTypes = {
  handleSearchArea: PropTypes.func
};

SearchAreaButton.defaultProps = {
  handleSearchArea: () => {}
}
